<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card :title="'Staff Qualifications'" cardBorder>
                <template slot="actions">
                    <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4 hidden"
                        color="primary" type="filled">Add New</vs-button>
                </template>
                <vx-card cardBorder noShadow titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters">
                    <div class="vx-row">
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Staff Users</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="true"
                                v-model="filters['staff-ids']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.value" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Qualifications</label>
                            <v-select name="timescale_type" :closeOnSelect="true" :clearable="true"
                                v-model="filters['skill-ids']" :options="qualification_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                :reduce="option => option.id" label="name" multiple>
                            </v-select>
                        </div>
                        <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                            <label class="text-sm opacity-100 text-bold">Qualification Categories</label>
                            <v-select :clearable="false" placeholder="" v-model="filters['categories']"
                                :options="categories" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" multiple
                                :reduce="option => option.id">
                            </v-select>
                        </div>
                    </div>
                    <div class="mt-5 vx-row">
                        <div class="w-full ml-auto vx-col">
                            <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                                icon-pack="feather" v-on:click="filters = {}">CLEAR</vs-button>
                        </div>
                    </div>
                </vx-card>
                <div id="manage-staff-qualification-table" class="vx-row">
                    <div class="w-full vx-col">

                        <vs-table stripe sort class="mt-8" :data="staff_qualifications">
                            <template slot="thead">
                                <vs-th width="15%">Name</vs-th>
                                <vs-th width="15%">Staff User</vs-th>
                                <vs-th width="10%">Category</vs-th>
                                <vs-th width="10%">Certification Number</vs-th>
                                <vs-th width="10%">Date Obtained</vs-th>
                                <vs-th width="10%">Expiry Date</vs-th>
                                <vs-th width="5%">Status</vs-th>
                                <vs-th width="15%">Notes</vs-th>
                                <vs-th width="10%"></vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].qualification.name">
                                        {{ data[indextr].qualification.name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].staff.name">
                                        {{ data[indextr].staff.name }} <br> 
                                        {{ data[indextr].staff.email }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].qualification.category.name">
                                        {{ data[indextr].qualification.category.name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].certification_number">
                                        {{ data[indextr].certification_number || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].description">
                                        {{ data[indextr].date_obtained || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].expiry_date">
                                        {{ data[indextr].expiry_date || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].is_active">
                                        <vs-chip transparent :color="data[indextr].status === 'Active' ? 'primary' : 'danger'">
                                            {{ data[indextr].status  }}
                                        </vs-chip>
                                    </vs-td>

                                    <vs-td :data="data[indextr].notes">
                                        {{ data[indextr].notes || 'N/A' }}
                                    </vs-td>

                                    <vs-td>
                                        <div class="justify-start vx-row">
                                            <vx-tooltip text="View/Update" position="left">
                                                <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3"
                                                    size="small" color="warning" type="border" icon-pack="feather"
                                                    icon="icon-edit-2"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip text="Delete Qualification" position="left">
                                                <vs-button @click.stop="onClickDeleteConfirmation(data[indextr].id)"
                                                    class="ml-3" size="small" color="danger" type="border"
                                                    icon-pack="feather" icon="icon-trash"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </vx-card>
        </div>
        <AddNewMyQulificationPopUp ref="addNewMyQulificationPopUp" />
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewMyQulificationPopUp from '@/components/popups/my-skill-qualifications/AddNewMyQulificationPopUp.vue'

import vSelect from 'vue-select'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { mapActions, mapGetters } from 'vuex';

import { defaultPagination, perPageList } from "@/constants/config";

const SkillQualificationRepository = RepositoryFactory.get('skills');

export default {
    name: "ManageStaffQualifications",
    data() {
        return {
            staff_qualifications: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            qualification_list: [],
            categories: []
        }
    },
    props: {
        staff_id: {
            type: String,
            required: true
        },
        action_buttons: {
            type: Boolean,
            default: true
        }
    },
    components: {
        AddNewMyQulificationPopUp,
        'v-select': vSelect,
    },
    methods: {
        ...mapActions(['fetchStaffs']),
        async refreshData() {
            await this.fetchStaffQualifications()
        },
        async fetchStaffQualifications() {
            await this.$vs.loading({
                container: '#manage-staff-qualification-table',
                scale: 0.45
            })
            const { data } = await SkillQualificationRepository.getListOfAllStaffQualifications(this.page, this.filterQuery, this.perPage, this.sort)
            this.staff_qualifications = data.data
            this.meta = data.meta
            this.$vs.loading.close('#manage-staff-qualification-table > .con-vs-loading')
        },
        async onClickAdd() {
            await this.$refs.addNewMyQulificationPopUp.openPopup()
        },
        async onClickUpdate(id) {
            await this.$refs.addNewMyQulificationPopUp.openPopup(id)
        },
        filterQueryUpdate() {
            this.fetchStaffQualifications()
        },
        handleChangePage(page) {
            this.page = page;
            this.fetchStaffQualifications()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchStaffQualifications()
            }
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        onClickDeleteConfirmation(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure you want to delete this ?',
                accept: this.onClickDelete,
                parameters: [id]
            })
        },
        async onClickDelete(params) {
            await this.$vs.loading({
                container: '#manage-staff-qualification-table',
                scale: 0.45
            })
            try {
                await SkillQualificationRepository.deleteMyQualifications(params[0])
                await this.refreshData()
            } catch (error) {

            } finally {
                this.$vs.loading.close('#manage-staff-qualification-table > .con-vs-loading')
            }
        },
        async fetchQualificationList() {
            await this.$vs.loading({
                container: '#manage-staff-qualification-table',
                scale: 0.45
            })
            try {
                const { data } = (await SkillQualificationRepository.getListOfSkillQualificationsDropdown()).data
                this.qualification_list = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#manage-staff-qualification-table > .con-vs-loading')
        },
        async fetchCategoryList() {
            await this.$vs.loading({
                container: '#manage-staff-qualification-table',
                scale: 0.45
            })
            try {
                const { data } = (await SkillQualificationRepository.getSkillQualificationCategoriesDropdown('Qualification')).data
                this.categories = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#manage-staff-qualification-table > .con-vs-loading')
        },
    },
    async mounted() {
        await this.fetchStaffs()
        await this.fetchQualificationList()
        await this.fetchCategoryList()
    },
    computed: {
        ...mapGetters(['staffs']),
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    watch: {
        page() {
            this.fetchStaffQualifications()
        },
        perPage() {
            this.fetchStaffQualifications()
        }
    }
}
</script>

<style scoped></style>